import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC-Ceww8fM6jOq8qsLgz5t34s0kX8vg3KM",
  authDomain: "e-commerce-54d85.firebaseapp.com",
  projectId: "e-commerce-54d85",
  storageBucket: "e-commerce-54d85.firebasestorage.app",
  messagingSenderId: "364291133810",
  appId: "1:364291133810:web:261dc7495d3f0ac4770deb",
  measurementId: "G-NFJD6KH1NN",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
export default app;
